import React, { useState, useCallback } from 'react'
import * as Yup from 'yup'

import PaywallEmailInput from 'components/set/Paywall/PaywallEmailInput/PaywallEmailInput'
import { PaywallContainer } from 'components/common/PaywallContainer/PaywallContainer'
import { PaywallDisplay, submitFreePass, getAlertMsg } from 'redux/slices/paywall'
import Button from 'components/common/Button/Button'
import { useDispatch, useSelector } from 'react-redux'

const validationSchema = Yup.object().shape({
    email: Yup.string()
        .email('Please enter a valid email address')
        .required('Please provide an email address'),
})

const PaywallFreeTierEmail: React.FC = () => {
    const dispatch = useDispatch()

    const [email, setEmail] = useState('')
    const [isValid, setValidity] = useState(false)

    const errorMsg = useSelector(getAlertMsg)

    const handleSubmition = useCallback(
        (e: React.FormEvent) => {
            e.preventDefault()
            dispatch(submitFreePass(email))
        },
        [dispatch, email],
    )

    return (
        <PaywallContainer goBackStep={PaywallDisplay.CHOOSE_PASS_TIER} onGoBack={() => {}}>
            <form onSubmit={handleSubmition}>
                <PaywallEmailInput
                    error={errorMsg}
                    validationSchema={validationSchema}
                    onValidChange={(valid, value) => {
                        setValidity(valid)
                        setEmail(value)
                    }}
                />
                <Button type="submit" maskType="secondary" fullWidth disabled={!isValid}>
                    Register
                </Button>
            </form>
        </PaywallContainer>
    )
}

export default React.memo(PaywallFreeTierEmail)
